import { Card, CardContent, Grid, TextField } from "@mui/material";
import Button from "@mui/material/Button";
import axios from "axios";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getCompounderByPhone, verifyOtp } from "../api/api";
import editIcon from "../assets/images/loginpgimgs/edit-icon.png";
import mobileIcon from "../assets/images/loginpgimgs/ic-contact-mobile.svg";

function OtpPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  // const [validationLevel, setValidationLevel] = useState(null);

  const mobileNumber = location.state?.mobileNumber || "";

  const handleOtpChange = (index, value) => {
    if (/^\d*$/.test(value) && value.length <= 1) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (value && index < 3) {
        document.getElementById(`otp-input-${index + 1}`)?.focus();
      }
    }
  };

  const handleSubmitOtp = async () => {
    const verificationCode = otp.join("");
    let reqBody = {
      user_no: mobileNumber,
      otp: verificationCode,
    };
    if (verificationCode.length !== 4) {
      setError("Please enter a 4-digit verification code");
      return;
    }

    setIsLoading(true);
    setError("");

    try {
      const response = await axios.post(verifyOtp, reqBody, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      console.log(response, "::>>handleSubmitOtp>>");
      if (response.status == 200) {
        toast.success(response.data.message);
        handleGetDoctorByPhone();
      }
      // if (response.data.status == "Approved") {
      //   sessionStorage.setItem(
      //     "loggedInUserData",
      //     JSON.stringify(response.data)
      //   );
      //   navigate("/validate-client-page", {
      //     replace: true,
      //     state: { completeData: response.data },
      //   });
      // } else {
      //   setError("Incorrect OTP");
      // }
    } catch (err) {
      setError(err.response.data.error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleGetDoctorByPhone = async () => {
    let reqBody = {
      phone_number: mobileNumber,
    };

    setIsLoading(true);
    setError("");

    try {
      const response = await axios.post(getCompounderByPhone, reqBody);
      console.log(response, "::>>handleGetDoctorByPhone>>");
      if (response.status == 200) {
        sessionStorage.setItem(
          "loggedInUserData",
          JSON.stringify(response.data)
        );
        navigate("/compounder-validate-page", {
          replace: true,
          state: { completeData: response.data },
        });
      }
    } catch (err) {
      console.log(err.response.data.error, "::>>errMessage>>");
      setError(err.response.data.error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Grid container spacing={0} className="otppage">
      <Grid size={{ xs: 12, md: 12 }}>
        <div className="d-flex justify-content-center align-items-center">
          <Card className="otpcard">
            <CardContent className="pb-16px w-100 mt-20px">
              <div className="otpTopDiv">
                <div className="otppgtext">
                  <p>Enter Verification Code {mobileNumber}</p>
                </div>

                <div className="d-flex justify-content-center align-items-center otpTopDivIcon">
                  <button
                    className="edit-button"
                    aria-label="Edit phone number"
                    onClick={() => navigate(-1)}
                  >
                    <span className="editIcon">
                      <img src={editIcon} alt="" role="presentation" />
                    </span>
                  </button>
                </div>
              </div>

              <div className="d-flex justify-content-center align-items-center">
                <span className="mobileBorder">
                  <img src={mobileIcon} alt="Mobile icon" />
                </span>
              </div>

              <Grid
                container
                spacing={0}
                className="d-flex justify-content-center align-items-center"
              >
                <Grid item xs={12}>
                  <p className="otpCode">Enter 4 Verification Code</p>
                </Grid>
              </Grid>

              <Grid container spacing={0} className="otptextfield">
                <div className="otpFieldDiv">
                  {[0, 1, 2, 3].map((index) => (
                    <Grid item xs={3} key={index}>
                      <TextField
                        id={`otp-input-${index}`}
                        value={otp[index]}
                        onChange={(e) => handleOtpChange(index, e.target.value)}
                        className={index === 0 ? "bluefield" : "whitefield"}
                      />
                    </Grid>
                  ))}
                </div>
              </Grid>

              {error && <div className="error-message">{error}</div>}

              <Button
                variant="contained"
                className="commonButton mt-20px"
                // onClick={handleSubmit}
                onClick={handleSubmitOtp}
                disabled={isLoading}
              >
                Next
              </Button>
            </CardContent>
          </Card>
        </div>
      </Grid>
    </Grid>
  );
}

export default OtpPage;
